import { memo } from 'react'

interface IFileTextIconProps {
  className?: string
  size?: number
}

const FileTextIcon: React.FC<IFileTextIconProps> = memo(
  ({ className, size = 24 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <rect x="2" y="4" width="12" height="9" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.06689 1.6C1.06689 1.17565 1.23547 0.768687 1.53552 0.468629C1.83558 0.168571 2.24255 0 2.66689 0L11.421 0L14.9336 3.51253V14.4C14.9336 14.8243 14.765 15.2313 14.4649 15.5314C14.1649 15.8314 13.7579 16 13.3336 16H2.66689C2.24255 16 1.83558 15.8314 1.53552 15.5314C1.23547 15.2313 1.06689 14.8243 1.06689 14.4V1.6ZM4.26689 4.26347L9.60023 4.26667V5.33333L4.26689 5.33013V4.26347ZM11.7336 7.46133H4.26689V8.528H11.7336V7.46133ZM11.7336 10.6677L4.26689 10.6592V11.7259L11.7336 11.7333V10.6677Z"
        fill="currentColor"
      />
    </svg>
  ),
)

export { FileTextIcon }
